export default "__VITE_ASSET__CBzof5TR__"